export default {
  setItems: items => ({ items }),
  fetch: () => async (state, actions) => {
    return fetch("/on-demand.json", {
      method: "GET",
      credentials: "same-origin",
      headers: {
        accept: "application/json"
      }
    })
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then(response => {
        actions.setItems(response.items);
      });
  }
};
